import store from "../store";

const generateShareLink = () => {

    console.log("generate share link");

    const { origin } = window.location;

    const backupData = store.getState()["visualizer"];

    var shareLink = origin + "/shared/";
    var mydata = {
        backup : backupData
    }; 
    var myimage = '{}';

    const shareData = {
        specifier:"",
        sel:"-1",
        url:shareLink,
        message:"Check out this design I made using Contour LVT Studio!"
    }

    // Avoid calling for actual lizard proxy if its
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortener(shareLink, "TarkettContour", JSON.stringify(mydata), myimage).then(function (r) {
            var arr = r.data.shortUrl.split('/');
            var stdShareUrl = shareLink + arr[arr.length - 1] + "/tkc";
            shareData["url"] = `https://tailoredbytarkett.chameleonpower.com/?redirect=${encodeURIComponent(stdShareUrl)}#app/contour`;

                if(stdShareUrl.indexOf("staging") !== -1){
                    shareData["url"] = `https://tarkettsuitestaging.chameleonpower.com/?redirect=${encodeURIComponent(stdShareUrl)}#app/contour`;
                }

            console.log(shareData);
            resolve(shareData);
            });
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve(shareData);
        });
    }
}

const loadShareLink = (code) => {
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}


const saveProjectToBoard = () => {

    if(window.location.href.indexOf("visualizer") !== -1){
        document.querySelector('#svg-container svg').setAttribute("width","800px")

        let workingSVG = document.querySelector('#svg-container svg').cloneNode(true);
    
        window.IMWC.svg.convertPatternImagesToBase64(workingSVG).then(function() {
            window.IMWC.svg.SVGToBase64JPG(workingSVG).then(function (base64) {
                document.querySelector('#svg-container svg').removeAttribute("width");
    
                let saveData = {
                    base64:base64
                }
    
                generateShareLink().then(shareData => {
                    window.parent.postMessage(JSON.stringify({
                        'action': 'projectSave',
                        'renderUrl': "",
                        'vizUrl': shareData.url,
                        'shareCode': shareData.url,
                        'appCode': 'contour',
                        'category': 'contour',
                        'base64':base64,
                        'productName': "test prod name",
                        'saveData': saveData,
                        'swatchData': {},
                        'products': "test products data"
                      }), '*');
                })
    
            });
        });
    }
    else if(window.location.href.indexOf("roomview") !== -1){
        
        let base64 = "" // document.getElementById("roomViewMain").getAttribute("src");

        if(document.getElementById("roomViewMain")){
            base64 = document.getElementById("roomViewMain").getAttribute("src");
        }

        let saveData = {
            base64:base64
        }
        generateShareLink().then(shareData => {
            window.parent.postMessage(JSON.stringify({
                'action': 'projectSave',
                'renderUrl': "",
                'vizUrl': shareData.url,
                'shareCode': shareData.url,
                'appCode': 'contour',
                'category': 'contour',
                'base64':base64,
                'productName': "test prod name",
                'saveData': saveData,
                'swatchData': {},
                'products': "test products data"
              }), '*');
        })
    }

} 

const saveProductToBoard = (product) => {

        let swatchData = {
            toolName: 'Contour',
            collectionName: product.name,
            name: product.color,
            thumb: `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=!${product.id}&type=prod&extra=(focus=500)&Size=400`,
            link: "https://commercial.tarkett.com/",
          }
        

        generateShareLink().then(shareData => {
            window.parent.postMessage(JSON.stringify({
                'action': 'swatchSave',
                'renderUrl':  `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?spec=!${product.id}&type=prod&extra=(focus=500)&Size=400`,
                'vizUrl': "",
                'shareCode': "",
                'appCode': 'contour',
                'category': 'contour',
                'base64':"",
                'productName': product.name +"-"+product.color,
                'saveData': {},
                'swatchData': swatchData,
                'products': [product.name +"-"+product.color]
              }), '*');
        })
    

} 

export {generateShareLink, loadShareLink, saveProjectToBoard, saveProductToBoard}

